import React from 'react';
import PropTypes from 'prop-types';

import Avatar from '@marvelapp/marvel-ui/avatar';
import Paragraph from '@marvelapp/marvel-ui/paragraph';
import Spacing from '@marvelapp/marvel-ui/spacing';

export default function CustomerQuoteBlock({
  quote,
  customerName,
  avatar,
  icon,
}) {
  return (
    <div>
      <Spacing size="xs" position="topBottom">
        <Paragraph size="l">"{quote}"</Paragraph>
      </Spacing>
      <Paragraph size="m" color="silver">
        {customerName}
      </Paragraph>
      <Spacing size="s" position="top" />
      <Avatar borderColor="white" image={avatar} teamImage={icon} />
    </div>
  );
}

CustomerQuoteBlock.propTypes = {
  avatar: PropTypes.string,
  customerName: PropTypes.string,
  icon: PropTypes.string,
  quote: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/modules/CustomerQuoteBlock/index.js